<template>
  <tr>
    <th class="px-4! py-2! text-left">Variation</th>
    <th class="w-24 px-4! py-2! text-right!">Traffic</th>
    <th v-if="!isInvisible" class="w-32 px-4! py-2! text-right!">Impressions</th>
    <th class="w-32 px-4! py-2! text-right!">{{ goalsTitle }}</th>
    <th class="w-32 px-4! py-2! text-right!">{{ conversionTitle }}</th>
    <th class="w-10 px-0! py-2!"></th>
  </tr>
</template>

<script setup>
import { computed } from "vue";
import { isInvisible as isInvisibleHelper } from "@/utils/prompts/promptHelpers";

const props = defineProps({ path: { type: Object, default: () => ({}) } });

const isInvisible = computed(() => isInvisibleHelper(props.path));
const goalsTitle = computed(() => (isInvisible.value ? "Users" : "Clicks"));
const conversionTitle = computed(() => (isInvisible.value ? "Conversion" : "CTR"));
</script>
